import React from 'react';
import styled from 'styled-components';
import {INVOICE_DIRECTIONS, INVOICE_SUBJECT_TYPES} from "../../../../Invoices/constants";

const Label = styled.span`
  padding: 2px 12px;
  text-align: center;
  border-radius: 5px;
  font-size: 12px;
  color: #fff;
  display: inline-block;
  white-space: nowrap;
  margin: 10px;
  width: 150px;
  background-color: ${props => {
  if (props.color) {
    return props.color;
  }

  if (props.type == INVOICE_SUBJECT_TYPES.VEHICLE) {
    return '#0083D5';
  }
  if (props.type == INVOICE_SUBJECT_TYPES.BPM) {
    return 'rgba(86,85,85,0.62)';
  }
  if (props.type == INVOICE_SUBJECT_TYPES.PRODUCT) {
    return '#b1a410';
  }
  if (props.type == INVOICE_SUBJECT_TYPES.COST) {
    return 'rgba(75,177,16,0.73)';
  }

  return '#3b3b3b';
}};
`;

export const InvoiceSubjectTypeLabel = ({ children, type }) => {
  return (
    <Label type={type}>
      {children}
    </Label>
  );
};
